export default __webpack_public_path__ + "static/media/person-4.fecc5b09.png";